<template>
    <div>
        <p class="surveys-common-label pb-0 mb-1" >
            {{`${requiredCharLabel}`}}
            <span v-if="sublabel" class="surveys-common-sublabel"><br> {{sublabel}}</span>
        </p>
        <div class="slider-input-form-custom-container">
            <v-slider
                :tick-labels="ticksLabers"
                :value="value"
                v-model="value"
                :min="min"
                :max="max"
                ticks="always"
                :tick-size="ticksLabers.length"
                dense
                :error-messages="errorMessage"
                class="slider-input-form-custom-label"
                track-color="primary"
                track-fill-color="primary"
                hide-details="auto"
            >
                <!-- <template v-slot:thumb-label="props">
                <v-icon dark>
                    {{ season(props.value) }}
                </v-icon>
                </template> -->
            </v-slider>    
        </div>
        <p class="pb-0 error--text caption mb-0 text-left" v-if="errorMessage"> {{errorMessage}} </p>
    </div>
</template>
<script>
export default {
    props: ['disabled','valueInput', 'rule', 'label', 'errorMessage', 'readonly', 'ticksLabers', 'min', 'max', 'asterisk', 'sublabel'],
    model: {
        prop: 'value',
        event: 'valueChange'
    },
    computed: {
        value: {
            get: function() {
                return this.valueInput
            },
            set: function(value) {
                if(value == null)
                    this.$emit('valueChange', 0)
                else
                    this.$emit('valueChange', value)
            }
        },
        requiredCharLabel:{
            get: function(){
                if(this.label == "" || this.label == undefined)
                    return "";
                const response = this.label + " *";
                for (let i = 0; i < (this?.rule?.length??[]); i++) {
                    if(this.rule[i]("") != true){
                        return response;
                    }
                }
                return this.label;
            }
        }
    },
    data(){
        return{
            autofillFix:false
        }
    },
    mounted(){
        
    },

    methods:{
       

    }
}
</script>
<style lang="scss">
    .slider-input-form-custom{
       

        &-label{
            font-size: .83rem;
            line-height: normal;
        }

        &-sublabel{
            font-style: italic;
            font-size: 0.73rem;
            color: #707070;
        }

        &-container{
            
            background-color: var(--v-inputsBackground-base);
            border-radius: 6px;
            padding-bottom: 0.8rem;
        }
    }

   
</style>